module.exports = __webpack_public_path__ + "static/media/straight-left.66053945.svg";